import { render, staticRenderFns } from "./user_update.vue?vue&type=template&id=8b1783ba&scoped=true&"
import script from "./user_update.vue?vue&type=script&lang=js&"
export * from "./user_update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1783ba",
  null
  
)

export default component.exports